import { render, staticRenderFns } from "./Result.vue?vue&type=template&id=8a28213e&scoped=true"
import script from "./Result.vue?vue&type=script&lang=ts"
export * from "./Result.vue?vue&type=script&lang=ts"
import style0 from "./Result.vue?vue&type=style&index=0&id=8a28213e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a28213e",
  null
  
)

export default component.exports